import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Drama, LogOut, Search } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { rolesOf } from "../lib/roles";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export function SimulationBanner() {
  const { simulating, user, stopSimulation } = useAuth();
  const nav = useNavigate();
  if (!simulating) return null;
  return (
    <div className="relative z-[45] bg-amber-500 text-[var(--navy-deep)] px-5 py-2.5 flex items-center justify-between gap-3" data-testid="simulation-banner">
      <p className="text-sm font-semibold flex items-center gap-2"><Drama className="w-4 h-4" />Operi come: {user.cognome} {user.nome} <span className="font-normal hidden sm:inline">· {rolesOf(user).join(", ")}</span></p>
      <Button size="sm" onClick={async () => { await stopSimulation(); nav("/admin"); toast.success("Simulazione terminata"); }} className="rounded-full bg-[var(--navy)] hover:bg-[var(--navy-deep)] text-white" data-testid="simulation-exit-button"><LogOut className="w-4 h-4 mr-1" />Esci</Button>
    </div>
  );
}

export function SimulationTrigger() {
  const { startSimulation, realUser } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (open) api("/admin/users").then((d) => setUsers((d.users || []).filter((u) => u.id !== realUser?.id && !u.is_admin && u.is_active !== false).sort((a, b) => (a.cognome || "").localeCompare(b.cognome || "") || (a.nome || "").localeCompare(b.nome || "")))).catch(() => toast.error("Errore caricamento dipendenti"));
  }, [open, realUser]);
  const list = users.filter((u) => `${u.cognome} ${u.nome}`.toLowerCase().includes(q.toLowerCase()));
  const pick = async (u) => { setOpen(false); await startSimulation(u); nav("/"); toast.success(`Ora operi come ${u.cognome} ${u.nome}`); };
  return (
    <>
      <button onClick={() => setOpen(true)} className="panel panel-hover !p-5 flex items-center gap-4 w-full text-left mb-10" data-testid="simulation-open-button">
        <span className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center"><Drama className="w-5 h-5 text-amber-700" /></span>
        <span><span className="block font-semibold text-[var(--navy)]">Simula un dipendente</span><span className="text-sm text-slate-500">Accedi e opera per conto di un dipendente, vedendo l'app con il suo ruolo</span></span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}><DialogContent><DialogHeader><DialogTitle>Scegli il dipendente</DialogTitle></DialogHeader>
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per cognome o nome" className="pl-9" data-testid="simulation-search-input" /></div>
        <div className="max-h-80 overflow-y-auto divide-y border rounded-xl">{list.length === 0 ? <p className="p-4 text-sm text-slate-500">Nessun dipendente trovato.</p> : list.map((u) => (
          <button key={u.id} onClick={() => pick(u)} className="w-full text-left px-4 py-2.5 hover:bg-slate-50" data-testid={`simulation-user-${u.id}`}><p className="font-medium text-sm">{u.cognome} {u.nome}</p><p className="text-xs text-slate-500">{rolesOf(u).join(", ")}</p></button>))}</div>
      </DialogContent></Dialog>
    </>
  );
}
